import axios from 'axios';

const imgToSvg = () => {
	let elements = [...document.getElementsByClassName('js-svg-replace')];

	elements.forEach(img => {
		if (img instanceof HTMLImageElement) {
			img.classList.remove('js-svg-replace');

			let url = img.getAttribute('src');
			let id = img.getAttribute('id');
			let classList = img.classList.toString();

			axios.get(url).then(content => {
				let container = document.createElement('div');
				container.innerHTML = content.data;

				let svg = container.firstChild;

				if (classList && classList.length) {
					svg.setAttribute('class', classList);
				}

				if(id && id.length) {
					svg.setAttribute('id', id);
				}

				img.replaceWith(svg);
			});
		}
	});
};

export default imgToSvg;


// WEBPACK FOOTER //
// ./js/core/Helpers/imgToSvg.js